import(/* webpackMode: "eager", webpackExports: ["default"] */ "/work/repo/common/components/BackgroundVideo.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/work/repo/common/components/ChatbotActionButton.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/work/repo/common/components/FAQCollapse.jsx");
;
import(/* webpackMode: "eager" */ "/work/repo/common/components/SectionWrapper.module.scss");
;
import(/* webpackMode: "eager" */ "/work/repo/common/components/SectionFAQ.module.scss");
;
import(/* webpackMode: "eager" */ "/work/repo/common/components/JoinUsSection.module.scss");
;
import(/* webpackMode: "eager" */ "/work/repo/node_modules/next/dist/client/image-component.js");
